import * as ALL_PROSPECTS_ACTION_TYPES from "./actionTypes"

// payload: { queryParams, appendResults }
export const getAllProspects = payload => ({
  type: ALL_PROSPECTS_ACTION_TYPES.GET_ALL_PROSPECTS,
  payload,
})

// payload: full API body { data, additional_data }; meta carries pagination/cache behavior
export const getAllProspectsSuccess = (payload, meta = {}) => ({
  type: ALL_PROSPECTS_ACTION_TYPES.GET_ALL_PROSPECTS_SUCCESS,
  payload,
  meta,
})

export const getAllProspectsError = error => ({
  type: ALL_PROSPECTS_ACTION_TYPES.GET_ALL_PROSPECTS_ERROR,
  payload: error,
})

// payload: { id, disposition } where id is a single id or an array of ids
export const updateCpaDisposition = payload => ({
  type: ALL_PROSPECTS_ACTION_TYPES.UPDATE_CPA_DISPOSITION,
  payload,
})

// payload: array of updated prospect objects returned by the API
export const updateCpaDispositionSuccess = payload => ({
  type: ALL_PROSPECTS_ACTION_TYPES.UPDATE_CPA_DISPOSITION_SUCCESS,
  payload,
})

export const updateCpaDispositionError = error => ({
  type: ALL_PROSPECTS_ACTION_TYPES.UPDATE_CPA_DISPOSITION_ERROR,
  payload: error,
})

// payload: { disposition, reason, id: [...] } or { disposition, reason, select_all: true, filters }
export const bulkEditCpaDisposition = payload => ({
  type: ALL_PROSPECTS_ACTION_TYPES.BULK_EDIT_CPA_DISPOSITION,
  payload,
})

// payload: the created/updated BulkEditJob
export const bulkEditCpaDispositionSuccess = bulkEditJob => ({
  type: ALL_PROSPECTS_ACTION_TYPES.BULK_EDIT_CPA_DISPOSITION_SUCCESS,
  payload: bulkEditJob,
})

export const bulkEditCpaDispositionError = error => ({
  type: ALL_PROSPECTS_ACTION_TYPES.BULK_EDIT_CPA_DISPOSITION_ERROR,
  payload: error,
})

export const getCpaBulkEditStatus = () => ({
  type: ALL_PROSPECTS_ACTION_TYPES.GET_CPA_BULK_EDIT_STATUS,
})

export const getCpaBulkEditStatusSuccess = bulkEditJob => ({
  type: ALL_PROSPECTS_ACTION_TYPES.GET_CPA_BULK_EDIT_STATUS_SUCCESS,
  payload: bulkEditJob,
})

export const getCpaBulkEditStatusError = error => ({
  type: ALL_PROSPECTS_ACTION_TYPES.GET_CPA_BULK_EDIT_STATUS_ERROR,
  payload: error,
})

// payload: same shape as bulkEditCpaDisposition's (minus reason, which isn't
// required server-side to preview how many records would be affected)
export const previewBulkEditCpaDisposition = payload => ({
  type: ALL_PROSPECTS_ACTION_TYPES.PREVIEW_CPA_BULK_EDIT,
  payload,
})

// payload: { count, target_key, lock_held, changes } from POST /bulk_edits/preview
export const previewBulkEditCpaDispositionSuccess = payload => ({
  type: ALL_PROSPECTS_ACTION_TYPES.PREVIEW_CPA_BULK_EDIT_SUCCESS,
  payload,
})

export const previewBulkEditCpaDispositionError = error => ({
  type: ALL_PROSPECTS_ACTION_TYPES.PREVIEW_CPA_BULK_EDIT_ERROR,
  payload: error,
})

// Clears the preview so a subsequent bulk edit doesn't briefly show the
// previous disposition's stale count while its own preview is loading.
export const resetCpaBulkEditPreview = () => ({
  type: ALL_PROSPECTS_ACTION_TYPES.RESET_CPA_BULK_EDIT_PREVIEW,
})
